var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "main-content sweet-modal-demo" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-sm-12" }, [
        _c("div", { staticClass: "card" }, [
          _vm._m(1),
          _vm._v(" "),
          _c("div", { staticClass: "card-body buttons-demo" }, [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-sm-6" },
                [
                  _c("h5", { staticClass: "section-semi-title" }, [
                    _vm._v("Basic Alerts")
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v("Simple alerts to notify about a particular status")
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.$refs.modal.open()
                        }
                      }
                    },
                    [_vm._v("\n                Regular\n              ")]
                  ),
                  _vm._v(" "),
                  _c("sweet-modal", { ref: "modal" }, [
                    _vm._v("This is a regular alert!")
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-success",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.$refs.success_modal.open()
                        }
                      }
                    },
                    [_vm._v("\n                Success\n              ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "sweet-modal",
                    { ref: "success_modal", attrs: { icon: "success" } },
                    [
                      _vm._v(
                        "\n                This is a success alert!\n              "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-warning",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.$refs.warning_modal.open()
                        }
                      }
                    },
                    [_vm._v("\n                Warning\n              ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "sweet-modal",
                    { ref: "warning_modal", attrs: { icon: "warning" } },
                    [
                      _vm._v(
                        "\n                This is a warning alert!\n              "
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-sm-6" },
                [
                  _c("h5", { staticClass: "section-semi-title" }, [
                    _vm._v("Custom Buttons")
                  ]),
                  _vm._v(" "),
                  _c("p", [_vm._v("Alert with a custom button & title")]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.$refs.error_modal.open()
                        }
                      }
                    },
                    [_vm._v("\n                Open\n              ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "sweet-modal",
                    {
                      ref: "error_modal",
                      attrs: { icon: "error", title: "Oh noes…" }
                    },
                    [
                      _vm._v(
                        "\n                This is an error…\n                "
                      ),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary",
                          attrs: { slot: "button", type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.$refs.error_modal.close()
                            }
                          },
                          slot: "button"
                        },
                        [
                          _vm._v(
                            "\n                  That's fine!\n                "
                          )
                        ]
                      )
                    ]
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row mt-5" }, [
              _c(
                "div",
                { staticClass: "col-sm-6" },
                [
                  _c("h5", { staticClass: "section-semi-title" }, [
                    _vm._v("Dark Theme")
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "It also supports a dark theme for modal and the modal overlay"
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.$refs.blocking_modal.open()
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                Dark with Blocking Error\n              "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "sweet-modal",
                    {
                      ref: "blocking_modal",
                      attrs: {
                        icon: "warning",
                        "hide-close-button": "",
                        blocking: "",
                        "overlay-theme": "dark",
                        "modal-theme": "dark"
                      }
                    },
                    [
                      _vm._v(
                        "\n                This is an error…\n                "
                      ),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-theme",
                          attrs: { slot: "button", type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.$refs.blocking_modal.close(
                                "darkWithBlockingError"
                              )
                            }
                          },
                          slot: "button"
                        },
                        [
                          _vm._v(
                            "\n                  Confirm\n                "
                          )
                        ]
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-sm-6" },
                [
                  _c("h5", { staticClass: "section-semi-title" }, [
                    _vm._v("Custom HTML")
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "You can add custom HTML as content for modal including Videos & tables (iframe)"
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.$refs.dark_html_modal.open()
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                Dark with HTML Content\n              "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "sweet-modal",
                    {
                      ref: "dark_html_modal",
                      attrs: { "modal-theme": "dark", "overlay-theme": "dark" }
                    },
                    [
                      _vm._v("\n                This is "),
                      _c("b", [_vm._v("HTML")]),
                      _vm._v("-"),
                      _c("i", [_vm._v("Content")]),
                      _vm._v(".\n                "),
                      _c("br"),
                      _c("br"),
                      _vm._v(" "),
                      _c("iframe", {
                        attrs: {
                          width: "560",
                          height: "315",
                          src: "https://www.youtube.com/embed/4xgx4k83zzc",
                          frameborder: "0",
                          allowfullscreen: ""
                        }
                      })
                    ]
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row mt-5" }, [
              _c(
                "div",
                { staticClass: "col-sm-6" },
                [
                  _c("h5", { staticClass: "section-semi-title" }, [
                    _vm._v("Window Controls")
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v("Add custom links or actions to the modal title")
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.$refs.additional_modal.open()
                        }
                      }
                    },
                    [_vm._v("\n                Open\n              ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "sweet-modal",
                    { ref: "additional_modal", attrs: { title: "Alert" } },
                    [
                      _vm._v(
                        "\n                This is an alert.\n                "
                      ),
                      _c("template", { slot: "box-action" }, [
                        _c("a", { attrs: { href: "#" } }, [_vm._v("Action 1")]),
                        _vm._v("  \n                  "),
                        _c("a", { attrs: { href: "#" } }, [_vm._v("Action 2")])
                      ])
                    ],
                    2
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-sm-6" },
                [
                  _c("h5", { staticClass: "section-semi-title" }, [
                    _vm._v("Custom Width")
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "Set a custom width to your modal based on your requirements"
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.$refs.wide_modal.open()
                        }
                      }
                    },
                    [_vm._v("\n                Open\n              ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "sweet-modal",
                    {
                      ref: "wide_modal",
                      attrs: { title: "Ultra Wide", width: "90%" }
                    },
                    [
                      _vm._v(
                        "\n                This is a very wide modal.\n              "
                      )
                    ]
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row mt-5" }, [
              _c(
                "div",
                { staticClass: "col-sm-6" },
                [
                  _c("h5", { staticClass: "section-semi-title" }, [
                    _vm._v("Nested Modals")
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "You can also have a nested modal which gets triggered by the parent modal thus allowing a possibility to have multiple modals to be open at a time"
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.$refs.nested.open()
                        }
                      }
                    },
                    [_vm._v("\n                Open\n              ")]
                  ),
                  _vm._v(" "),
                  _c("sweet-modal", { ref: "nested" }, [
                    _vm._v(
                      "\n                This is the parent modal.\n                "
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary",
                        attrs: { slot: "button", type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.$refs.nestedChild.open()
                          }
                        },
                        slot: "button"
                      },
                      [
                        _vm._v(
                          "\n                  Open Child Modal\n                "
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("sweet-modal", { ref: "nestedChild" }, [
                    _vm._v(
                      "\n                This is the child modal.\n              "
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-sm-6" },
                [
                  _c("h5", { staticClass: "section-semi-title" }, [
                    _vm._v("Long Scrolling Modal")
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "You can add as much content as you wish! It'll automatically scroll"
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.$refs.long_modal.open()
                        }
                      }
                    },
                    [_vm._v("\n                Open\n              ")]
                  ),
                  _vm._v(" "),
                  _c("sweet-modal", { ref: "long_modal" }, [
                    _vm._v(
                      "\n                Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod\n                tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,\n                quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo\n                consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse\n                cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non\n                proident, sunt in culpa qui officia deserunt mollit anim id est laborum.\n                Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod\n                tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,\n                quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo\n                consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse\n                cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non\n                proident, sunt in culpa qui officia deserunt mollit anim id est laborum.\n                Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod\n                tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,\n                quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo\n                consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse\n                cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non\n                proident, sunt in culpa qui officia deserunt mollit anim id est laborum.\n                Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod\n                tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,\n                quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo\n                consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse\n                cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non\n                proident, sunt in culpa qui officia deserunt mollit anim id est laborum.\n                Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod\n                tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,\n                quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo\n                consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse\n                cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non\n                proident, sunt in culpa qui officia deserunt mollit anim id est laborum.\n                Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod\n                tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,\n                quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo\n                consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse\n                cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non\n                proident, sunt in culpa qui officia deserunt mollit anim id est laborum.\n                Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod\n                tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,\n                quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo\n                consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse\n                cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non\n                proident, sunt in culpa qui officia deserunt mollit anim id est laborum.\n                Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod\n                tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,\n                quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo\n                consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse\n                cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non\n                proident, sunt in culpa qui officia deserunt mollit anim id est laborum.\n                Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod\n                tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,\n                quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo\n                consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse\n                cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non\n                proident, sunt in culpa qui officia deserunt mollit anim id est laborum.\n                Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod\n                tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,\n                quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo\n                consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse\n                cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non\n                proident, sunt in culpa qui officia deserunt mollit anim id est laborum.\n                Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod\n                tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,\n                quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo\n                consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse\n                cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non\n                proident, sunt in culpa qui officia deserunt mollit anim id est laborum.\n                Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod\n                tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,\n                quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo\n                consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse\n                cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non\n                proident, sunt in culpa qui officia deserunt mollit anim id est laborum.\n                Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod\n                tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,\n                quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo\n                consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse\n                cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non\n                proident, sunt in culpa qui officia deserunt mollit anim id est laborum.\n                Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod\n                tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,\n                quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo\n                consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse\n                cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non\n                proident, sunt in culpa qui officia deserunt mollit anim id est laborum.\n                Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod\n                tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,\n                quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo\n                consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse\n                cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non\n                proident, sunt in culpa qui officia deserunt mollit anim id est laborum.\n              "
                    )
                  ])
                ],
                1
              )
            ])
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-sm-12" }, [
        _c("div", { staticClass: "card" }, [
          _vm._m(2),
          _vm._v(" "),
          _c("div", { staticClass: "card-body buttons-demo" }, [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-sm-6" },
                [
                  _c("h5", { staticClass: "section-semi-title" }, [
                    _vm._v("Basic")
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "You can have tabs directly inside the modal content"
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.$refs.tabbed_modal.open()
                        }
                      }
                    },
                    [_vm._v("\n                Open\n              ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "sweet-modal",
                    { ref: "tabbed_modal" },
                    [
                      _c(
                        "sweet-modal-tab",
                        { attrs: { id: "tab1", title: "Tab 1" } },
                        [
                          _vm._v(
                            "\n                  Contents of Tab 1\n                "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "sweet-modal-tab",
                        { attrs: { id: "tab2", title: "Tab 2" } },
                        [
                          _vm._v(
                            "\n                  Contents of Tab 2\n                "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "sweet-modal-tab",
                        { attrs: { id: "tab3", title: "Tab 3", disabled: "" } },
                        [
                          _vm._v(
                            "\n                  Tab 3 is disabled\n                "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-sm-6" },
                [
                  _c("h5", { staticClass: "section-semi-title" }, [
                    _vm._v("With Icons")
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "Use custom icons to represent the tabs instead of just a boring title"
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.$refs.tabbed_modal_icon.open()
                        }
                      }
                    },
                    [_vm._v("\n                Open\n              ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "sweet-modal",
                    { ref: "tabbed_modal_icon" },
                    [
                      _c(
                        "sweet-modal-tab",
                        {
                          attrs: {
                            id: "tab1",
                            icon: _vm.icons_anchor,
                            title: "Tab 1"
                          }
                        },
                        [
                          _vm._v(
                            "\n                  Contents of Tab 1\n                "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "sweet-modal-tab",
                        {
                          attrs: {
                            id: "tab2",
                            icon: _vm.icons_sun,
                            title: "Tab 2"
                          }
                        },
                        [
                          _vm._v(
                            "\n                  Contents of Tab 2\n                "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "sweet-modal-tab",
                        {
                          attrs: {
                            id: "tab3",
                            icon: _vm.icons_leaf,
                            title: "Tab 3",
                            disabled: ""
                          }
                        },
                        [
                          _vm._v(
                            "\n                  Tab 3 is disabled\n                "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row mt-5" }, [
              _c(
                "div",
                { staticClass: "col-sm-6" },
                [
                  _c("h5", { staticClass: "section-semi-title" }, [
                    _vm._v("Custom Icon and Buttons")
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "Use a custom icon and multiple actions inside the modal"
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.$refs.tabbed_modal_icon_button.open()
                        }
                      }
                    },
                    [_vm._v("\n                Open\n              ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "sweet-modal",
                    { ref: "tabbed_modal_icon_button" },
                    [
                      _c(
                        "sweet-modal-tab",
                        {
                          attrs: {
                            id: "tab1",
                            icon: _vm.icons_anchor,
                            title: "Tab 1"
                          }
                        },
                        [
                          _vm._v(
                            "\n                  Contents of Tab 1\n                "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "sweet-modal-tab",
                        {
                          attrs: {
                            id: "tab2",
                            icon: _vm.icons_sun,
                            title: "Tab 2"
                          }
                        },
                        [
                          _vm._v(
                            "\n                  Contents of Tab 2\n                "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "sweet-modal-tab",
                        {
                          attrs: {
                            id: "tab3",
                            icon: _vm.icons_leaf,
                            title: "Tab 3",
                            disabled: ""
                          }
                        },
                        [
                          _vm._v(
                            "\n                  Tab 3 is disabled\n                "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary",
                          attrs: { slot: "button", type: "button" },
                          slot: "button"
                        },
                        [
                          _vm._v(
                            "\n                  Action1\n                "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary",
                          attrs: { slot: "button", type: "button" },
                          slot: "button"
                        },
                        [
                          _vm._v(
                            "\n                  Action2\n                "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-header" }, [
      _c("h3", { staticClass: "page-title" }, [_vm._v("Modals")]),
      _vm._v(" "),
      _c("ol", { staticClass: "breadcrumb" }, [
        _c("li", { staticClass: "breadcrumb-item" }, [
          _c("a", { attrs: { href: "#" } }, [_vm._v("Home")])
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "breadcrumb-item" }, [
          _c("a", { attrs: { href: "#" } }, [_vm._v("Components")])
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "breadcrumb-item active" }, [_vm._v("Modals")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-header" }, [
      _c("h6", [_vm._v("Simple Modals")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-header" }, [
      _c("h6", [_vm._v("Tabbed Modals")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0bdbcf9c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0bdbcf9c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/views/admin/components/SweetModals.vue
// module id = 683
// module chunks = 0